module.exports = __webpack_public_path__ + "img/abTest-personalization.283299fb.png";